export const IconJson = {
  "ep:": [
    "add-location",
    "aim",
    "alarm-clock",
    "apple",
    "arrow-down",
    "arrow-down-bold",
    "arrow-left",
    "arrow-left-bold",
    "arrow-right",
    "arrow-right-bold",
    "arrow-up",
    "arrow-up-bold",
    "avatar",
    "back",
    "baseball",
    "basketball",
    "bell",
    "bell-filled",
    "bicycle",
    "bottom",
    "bottom-left",
    "bottom-right",
    "bowl",
    "box",
    "briefcase",
    "brush",
    "brush-filled",
    "burger",
    "calendar",
    "camera",
    "camera-filled",
    "caret-bottom",
    "caret-left",
    "caret-right",
    "caret-top",
    "cellphone",
    "chat-dot-round",
    "chat-dot-square",
    "chat-line-round",
    "chat-line-square",
    "chat-round",
    "chat-square",
    "check",
    "checked",
    "cherry",
    "chicken",
    "circle-check",
    "circle-check-filled",
    "circle-close",
    "circle-close-filled",
    "circle-plus",
    "circle-plus-filled",
    "clock",
    "close",
    "close-bold",
    "cloudy",
    "coffee",
    "coffee-cup",
    "coin",
    "cold-drink",
    "collection",
    "collection-tag",
    "comment",
    "compass",
    "connection",
    "coordinate",
    "copy-document",
    "cpu",
    "credit-card",
    "crop",
    "d-arrow-left",
    "d-arrow-right",
    "d-caret",
    "data-analysis",
    "data-board",
    "data-line",
    "delete",
    "delete-filled",
    "delete-location",
    "dessert",
    "discount",
    "dish",
    "dish-dot",
    "document",
    "document-add",
    "document-checked",
    "document-copy",
    "document-delete",
    "document-remove",
    "download",
    "drizzling",
    "edit",
    "edit-pen",
    "eleme",
    "eleme-filled",
    "expand",
    "failed",
    "female",
    "files",
    "film",
    "filter",
    "finished",
    "first-aid-kit",
    "flag",
    "fold",
    "folder",
    "folder-add",
    "folder-checked",
    "folder-delete",
    "folder-opened",
    "folder-remove",
    "food",
    "football",
    "fork-spoon",
    "fries",
    "full-screen",
    "goblet",
    "goblet-full",
    "goblet-square",
    "goblet-square-full",
    "goods",
    "goods-filled",
    "grape",
    "grid",
    "guide",
    "headset",
    "help",
    "help-filled",
    "histogram",
    "home-filled",
    "hot-water",
    "house",
    "ice-cream",
    "ice-cream-round",
    "ice-cream-square",
    "ice-drink",
    "ice-tea",
    "info-filled",
    "iphone",
    "key",
    "knife-fork",
    "lightning",
    "link",
    "list",
    "loading",
    "location",
    "location-filled",
    "location-information",
    "lock",
    "lollipop",
    "magic-stick",
    "magnet",
    "male",
    "management",
    "map-location",
    "medal",
    "menu",
    "message",
    "message-box",
    "mic",
    "microphone",
    "milk-tea",
    "minus",
    "money",
    "monitor",
    "moon",
    "moon-night",
    "more",
    "more-filled",
    "mostly-cloudy",
    "mouse",
    "mug",
    "mute",
    "mute-notification",
    "no-smoking",
    "notebook",
    "notification",
    "odometer",
    "office-building",
    "open",
    "operation",
    "opportunity",
    "orange",
    "paperclip",
    "partly-cloudy",
    "pear",
    "phone",
    "phone-filled",
    "picture",
    "picture-filled",
    "picture-rounded",
    "pie-chart",
    "place",
    "platform",
    "plus",
    "pointer",
    "position",
    "postcard",
    "pouring",
    "present",
    "price-tag",
    "printer",
    "promotion",
    "question-filled",
    "rank",
    "reading",
    "reading-lamp",
    "refresh",
    "refresh-left",
    "refresh-right",
    "refrigerator",
    "remove",
    "remove-filled",
    "right",
    "scale-to-original",
    "school",
    "scissor",
    "search",
    "select",
    "sell",
    "semi-select",
    "service",
    "set-up",
    "setting",
    "share",
    "ship",
    "shop",
    "shopping-bag",
    "shopping-cart",
    "shopping-cart-full",
    "smoking",
    "soccer",
    "sold-out",
    "sort",
    "sort-down",
    "sort-up",
    "stamp",
    "star",
    "star-filled",
    "stopwatch",
    "success-filled",
    "sugar",
    "suitcase",
    "sunny",
    "sunrise",
    "sunset",
    "switch",
    "switch-button",
    "takeaway-box",
    "ticket",
    "tickets",
    "timer",
    "toilet-paper",
    "tools",
    "top",
    "top-left",
    "top-right",
    "trend-charts",
    "trophy",
    "turn-off",
    "umbrella",
    "unlock",
    "upload",
    "upload-filled",
    "user",
    "user-filled",
    "van",
    "video-camera",
    "video-camera-filled",
    "video-pause",
    "video-play",
    "view",
    "wallet",
    "wallet-filled",
    "warning",
    "warning-filled",
    "watch",
    "watermelon",
    "wind-power",
    "zoom-in",
    "zoom-out",
  ],
  "fa:": [
    "500px",
    "address-book",
    "address-book-o",
    "address-card",
    "address-card-o",
    "adjust",
    "adn",
    "align-center",
    "align-justify",
    "align-left",
    "amazon",
    "ambulance",
    "american-sign-language-interpreting",
    "anchor",
    "android",
    "angellist",
    "angle-double-left",
    "angle-double-up",
    "angle-down",
    "angle-left",
    "angle-up",
    "apple",
    "archive",
    "area-chart",
    "arrow-circle-left",
    "arrow-circle-o-left",
    "arrow-circle-o-up",
    "arrow-circle-up",
    "arrow-left",
    "arrow-up",
    "arrows",
    "arrows-alt",
    "arrows-h",
    "arrows-v",
    "assistive-listening-systems",
    "asterisk",
    "at",
    "audio-description",
    "automobile",
    "backward",
    "balance-scale",
    "ban",
    "bandcamp",
    "bank",
    "bar-chart",
    "barcode",
    "bars",
    "bath",
    "battery",
    "battery-0",
    "battery-1",
    "battery-2",
    "battery-3",
    "bed",
    "beer",
    "behance",
    "behance-square",
    "bell",
    "bell-o",
    "bell-slash",
    "bell-slash-o",
    "bicycle",
    "binoculars",
    "birthday-cake",
    "bitbucket",
    "bitbucket-square",
    "bitcoin",
    "black-tie",
    "blind",
    "bluetooth",
    "bluetooth-b",
    "bold",
    "bolt",
    "bomb",
    "book",
    "bookmark",
    "bookmark-o",
    "braille",
    "briefcase",
    "bug",
    "building",
    "building-o",
    "bullhorn",
    "bullseye",
    "bus",
    "buysellads",
    "cab",
    "calculator",
    "calendar",
    "calendar-check-o",
    "calendar-minus-o",
    "calendar-o",
    "calendar-plus-o",
    "calendar-times-o",
    "camera",
    "camera-retro",
    "caret-down",
    "caret-left",
    "caret-square-o-left",
    "caret-square-o-up",
    "caret-up",
    "cart-arrow-down",
    "cart-plus",
    "cc",
    "cc-amex",
    "cc-diners-club",
    "cc-discover",
    "cc-jcb",
    "cc-mastercard",
    "cc-paypal",
    "cc-stripe",
    "cc-visa",
    "certificate",
    "chain",
    "chain-broken",
    "check",
    "check-circle",
    "check-circle-o",
    "check-square",
    "check-square-o",
    "chevron-circle-left",
    "chevron-circle-up",
    "chevron-down",
    "chevron-left",
    "chevron-up",
    "child",
    "chrome",
    "circle",
    "circle-o",
    "circle-o-notch",
    "circle-thin",
    "clipboard",
    "clock-o",
    "clone",
    "close",
    "cloud",
    "cloud-download",
    "cloud-upload",
    "cny",
    "code",
    "code-fork",
    "codepen",
    "codiepie",
    "coffee",
    "cog",
    "cogs",
    "columns",
    "comment",
    "comment-o",
    "commenting",
    "commenting-o",
    "comments",
    "comments-o",
    "compass",
    "compress",
    "connectdevelop",
    "contao",
    "copy",
    "copyright",
    "creative-commons",
    "credit-card",
    "credit-card-alt",
    "crop",
    "crosshairs",
    "css3",
    "cube",
    "cubes",
    "cut",
    "cutlery",
    "dashboard",
    "dashcube",
    "database",
    "deaf",
    "dedent",
    "delicious",
    "desktop",
    "deviantart",
    "diamond",
    "digg",
    "dollar",
    "dot-circle-o",
    "download",
    "dribbble",
    "drivers-license",
    "drivers-license-o",
    "dropbox",
    "drupal",
    "edge",
    "edit",
    "eercast",
    "eject",
    "ellipsis-h",
    "ellipsis-v",
    "empire",
    "envelope",
    "envelope-o",
    "envelope-open",
    "envelope-open-o",
    "envelope-square",
    "envira",
    "eraser",
    "etsy",
    "eur",
    "exchange",
    "exclamation",
    "exclamation-circle",
    "exclamation-triangle",
    "expand",
    "expeditedssl",
    "external-link",
    "external-link-square",
    "eye",
    "eye-slash",
    "eyedropper",
    "fa",
    "facebook",
    "facebook-official",
    "facebook-square",
    "fast-backward",
    "fax",
    "feed",
    "female",
    "fighter-jet",
    "file",
    "file-archive-o",
    "file-audio-o",
    "file-code-o",
    "file-excel-o",
    "file-image-o",
    "file-movie-o",
    "file-o",
    "file-pdf-o",
    "file-powerpoint-o",
    "file-text",
    "file-text-o",
    "file-word-o",
    "film",
    "filter",
    "fire",
    "fire-extinguisher",
    "firefox",
    "first-order",
    "flag",
    "flag-checkered",
    "flag-o",
    "flask",
    "flickr",
    "floppy-o",
    "folder",
    "folder-o",
    "folder-open",
    "folder-open-o",
    "font",
    "fonticons",
    "fort-awesome",
    "forumbee",
    "foursquare",
    "free-code-camp",
    "frown-o",
    "futbol-o",
    "gamepad",
    "gavel",
    "gbp",
    "genderless",
    "get-pocket",
    "gg",
    "gg-circle",
    "gift",
    "git",
    "git-square",
    "github",
    "github-alt",
    "github-square",
    "gitlab",
    "gittip",
    "glass",
    "glide",
    "glide-g",
    "globe",
    "google",
    "google-plus",
    "google-plus-circle",
    "google-plus-square",
    "google-wallet",
    "graduation-cap",
    "grav",
    "group",
    "h-square",
    "hacker-news",
    "hand-grab-o",
    "hand-lizard-o",
    "hand-o-left",
    "hand-o-up",
    "hand-paper-o",
    "hand-peace-o",
    "hand-pointer-o",
    "hand-scissors-o",
    "hand-spock-o",
    "handshake-o",
    "hashtag",
    "hdd-o",
    "header",
    "headphones",
    "heart",
    "heart-o",
    "heartbeat",
    "history",
    "home",
    "hospital-o",
    "hourglass",
    "hourglass-1",
    "hourglass-2",
    "hourglass-3",
    "hourglass-o",
    "houzz",
    "html5",
    "i-cursor",
    "id-badge",
    "ils",
    "image",
    "imdb",
    "inbox",
    "indent",
    "industry",
    "info",
    "info-circle",
    "inr",
    "instagram",
    "internet-explorer",
    "intersex",
    "ioxhost",
    "italic",
    "joomla",
    "jsfiddle",
    "key",
    "keyboard-o",
    "krw",
    "language",
    "laptop",
    "lastfm",
    "lastfm-square",
    "leaf",
    "leanpub",
    "lemon-o",
    "level-up",
    "life-bouy",
    "lightbulb-o",
    "line-chart",
    "linkedin",
    "linkedin-square",
    "linode",
    "linux",
    "list",
    "list-alt",
    "list-ol",
    "list-ul",
    "location-arrow",
    "lock",
    "long-arrow-left",
    "long-arrow-up",
    "low-vision",
    "magic",
    "magnet",
    "mail-forward",
    "mail-reply",
    "mail-reply-all",
    "male",
    "map",
    "map-marker",
    "map-o",
    "map-pin",
    "map-signs",
    "mars",
    "mars-double",
    "mars-stroke",
    "mars-stroke-h",
    "mars-stroke-v",
    "maxcdn",
    "meanpath",
    "medium",
    "medkit",
    "meetup",
    "meh-o",
    "mercury",
    "microchip",
    "microphone",
    "microphone-slash",
    "minus",
    "minus-circle",
    "minus-square",
    "minus-square-o",
    "mixcloud",
    "mobile",
    "modx",
    "money",
    "moon-o",
    "motorcycle",
    "mouse-pointer",
    "music",
    "neuter",
    "newspaper-o",
    "object-group",
    "object-ungroup",
    "odnoklassniki",
    "odnoklassniki-square",
    "opencart",
    "openid",
    "opera",
    "optin-monster",
    "pagelines",
    "paint-brush",
    "paper-plane",
    "paper-plane-o",
    "paperclip",
    "paragraph",
    "pause",
    "pause-circle",
    "pause-circle-o",
    "paw",
    "paypal",
    "pencil",
    "pencil-square",
    "percent",
    "phone",
    "phone-square",
    "pie-chart",
    "pied-piper",
    "pied-piper-alt",
    "pied-piper-pp",
    "pinterest",
    "pinterest-p",
    "pinterest-square",
    "plane",
    "play",
    "play-circle",
    "play-circle-o",
    "plug",
    "plus",
    "plus-circle",
    "plus-square",
    "plus-square-o",
    "podcast",
    "power-off",
    "print",
    "product-hunt",
    "puzzle-piece",
    "qq",
    "qrcode",
    "question",
    "question-circle",
    "question-circle-o",
    "quora",
    "quote-left",
    "quote-right",
    "ra",
    "random",
    "ravelry",
    "recycle",
    "reddit",
    "reddit-alien",
    "reddit-square",
    "refresh",
    "registered",
    "renren",
    "repeat",
    "retweet",
    "road",
    "rocket",
    "rotate-left",
    "rouble",
    "rss-square",
    "safari",
    "scribd",
    "search",
    "search-minus",
    "search-plus",
    "sellsy",
    "server",
    "share-alt",
    "share-alt-square",
    "share-square",
    "share-square-o",
    "shield",
    "ship",
    "shirtsinbulk",
    "shopping-bag",
    "shopping-basket",
    "shopping-cart",
    "shower",
    "sign-in",
    "sign-language",
    "sign-out",
    "signal",
    "simplybuilt",
    "sitemap",
    "skyatlas",
    "skype",
    "slack",
    "sliders",
    "slideshare",
    "smile-o",
    "snapchat",
    "snapchat-ghost",
    "snapchat-square",
    "snowflake-o",
    "sort",
    "sort-alpha-asc",
    "sort-alpha-desc",
    "sort-amount-asc",
    "sort-amount-desc",
    "sort-asc",
    "sort-numeric-asc",
    "sort-numeric-desc",
    "soundcloud",
    "space-shuttle",
    "spinner",
    "spoon",
    "spotify",
    "square",
    "square-o",
    "stack-exchange",
    "stack-overflow",
    "star",
    "star-half",
    "star-half-empty",
    "star-o",
    "steam",
    "steam-square",
    "step-backward",
    "stethoscope",
    "sticky-note",
    "sticky-note-o",
    "stop",
    "stop-circle",
    "stop-circle-o",
    "street-view",
    "strikethrough",
    "stumbleupon",
    "stumbleupon-circle",
    "subscript",
    "subway",
    "suitcase",
    "sun-o",
    "superpowers",
    "superscript",
    "table",
    "tablet",
    "tag",
    "tags",
    "tasks",
    "telegram",
    "television",
    "tencent-weibo",
    "terminal",
    "text-height",
    "text-width",
    "th",
    "th-large",
    "th-list",
    "themeisle",
    "thermometer",
    "thermometer-0",
    "thermometer-1",
    "thermometer-2",
    "thermometer-3",
    "thumb-tack",
    "thumbs-down",
    "thumbs-o-up",
    "thumbs-up",
    "ticket",
    "times-circle",
    "times-circle-o",
    "times-rectangle",
    "times-rectangle-o",
    "tint",
    "toggle-off",
    "toggle-on",
    "trademark",
    "train",
    "transgender-alt",
    "trash",
    "trash-o",
    "tree",
    "trello",
    "tripadvisor",
    "trophy",
    "truck",
    "try",
    "tty",
    "tumblr",
    "tumblr-square",
    "twitch",
    "twitter",
    "twitter-square",
    "umbrella",
    "underline",
    "universal-access",
    "unlock",
    "unlock-alt",
    "upload",
    "usb",
    "user",
    "user-circle",
    "user-circle-o",
    "user-md",
    "user-o",
    "user-plus",
    "user-secret",
    "user-times",
    "venus",
    "venus-double",
    "venus-mars",
    "viacoin",
    "viadeo",
    "viadeo-square",
    "video-camera",
    "vimeo",
    "vimeo-square",
    "vine",
    "vk",
    "volume-control-phone",
    "volume-down",
    "volume-off",
    "volume-up",
    "wechat",
    "weibo",
    "whatsapp",
    "wheelchair",
    "wheelchair-alt",
    "wifi",
    "wikipedia-w",
    "window-maximize",
    "window-minimize",
    "window-restore",
    "windows",
    "wordpress",
    "wpbeginner",
    "wpexplorer",
    "wpforms",
    "wrench",
    "xing",
    "xing-square",
    "y-combinator",
    "yahoo",
    "yelp",
    "yoast",
    "youtube",
    "youtube-play",
    "youtube-square",
  ],
  "fa-solid:": [
    "abacus",
    "ad",
    "address-book",
    "address-card",
    "adjust",
    "air-freshener",
    "align-center",
    "align-justify",
    "align-left",
    "align-right",
    "allergies",
    "ambulance",
    "american-sign-language-interpreting",
    "anchor",
    "angle-double-down",
    "angle-double-left",
    "angle-double-right",
    "angle-double-up",
    "angle-down",
    "angle-left",
    "angle-right",
    "angle-up",
    "angry",
    "ankh",
    "apple-alt",
    "archive",
    "archway",
    "arrow-alt-circle-down",
    "arrow-alt-circle-left",
    "arrow-alt-circle-right",
    "arrow-alt-circle-up",
    "arrow-circle-down",
    "arrow-circle-left",
    "arrow-circle-right",
    "arrow-circle-up",
    "arrow-down",
    "arrow-left",
    "arrow-right",
    "arrow-up",
    "arrows-alt",
    "arrows-alt-h",
    "arrows-alt-v",
    "assistive-listening-systems",
    "asterisk",
    "at",
    "atlas",
    "atom",
    "audio-description",
    "award",
    "baby",
    "baby-carriage",
    "backspace",
    "backward",
    "bacon",
    "bacteria",
    "bacterium",
    "bahai",
    "balance-scale",
    "balance-scale-left",
    "balance-scale-right",
    "ban",
    "band-aid",
    "barcode",
    "bars",
    "baseball-ball",
    "basketball-ball",
    "bath",
    "battery-empty",
    "battery-full",
    "battery-half",
    "battery-quarter",
    "battery-three-quarters",
    "bed",
    "beer",
    "bell",
    "bell-slash",
    "bezier-curve",
    "bible",
    "bicycle",
    "biking",
    "binoculars",
    "biohazard",
    "birthday-cake",
    "blender",
    "blender-phone",
    "blind",
    "blog",
    "bold",
    "bolt",
    "bomb",
    "bone",
    "bong",
    "book",
    "book-dead",
    "book-medical",
    "book-open",
    "book-reader",
    "bookmark",
    "border-all",
    "border-none",
    "border-style",
    "bowling-ball",
    "box",
    "box-open",
    "box-tissue",
    "boxes",
    "braille",
    "brain",
    "bread-slice",
    "briefcase",
    "briefcase-medical",
    "broadcast-tower",
    "broom",
    "brush",
    "bug",
    "building",
    "bullhorn",
    "bullseye",
    "burn",
    "bus",
    "bus-alt",
    "business-time",
    "calculator",
    "calculator-alt",
    "calendar",
    "calendar-alt",
    "calendar-check",
    "calendar-day",
    "calendar-minus",
    "calendar-plus",
    "calendar-times",
    "calendar-week",
    "camera",
    "camera-retro",
    "campground",
    "candy-cane",
    "cannabis",
    "capsules",
    "car",
    "car-alt",
    "car-battery",
    "car-crash",
    "car-side",
    "caravan",
    "caret-down",
    "caret-left",
    "caret-right",
    "caret-square-down",
    "caret-square-left",
    "caret-square-right",
    "caret-square-up",
    "caret-up",
    "carrot",
    "cart-arrow-down",
    "cart-plus",
    "cash-register",
    "cat",
    "certificate",
    "chair",
    "chalkboard",
    "chalkboard-teacher",
    "charging-station",
    "chart-area",
    "chart-bar",
    "chart-line",
    "chart-pie",
    "check",
    "check-circle",
    "check-double",
    "check-square",
    "cheese",
    "chess",
    "chess-bishop",
    "chess-board",
    "chess-king",
    "chess-knight",
    "chess-pawn",
    "chess-queen",
    "chess-rook",
    "chevron-circle-down",
    "chevron-circle-left",
    "chevron-circle-right",
    "chevron-circle-up",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevron-up",
    "child",
    "church",
    "circle",
    "circle-notch",
    "city",
    "clinic-medical",
    "clipboard",
    "clipboard-check",
    "clipboard-list",
    "clock",
    "clone",
    "closed-captioning",
    "cloud",
    "cloud-download-alt",
    "cloud-meatball",
    "cloud-moon",
    "cloud-moon-rain",
    "cloud-rain",
    "cloud-showers-heavy",
    "cloud-sun",
    "cloud-sun-rain",
    "cloud-upload-alt",
    "cocktail",
    "code",
    "code-branch",
    "coffee",
    "cog",
    "cogs",
    "coins",
    "columns",
    "comment",
    "comment-alt",
    "comment-dollar",
    "comment-dots",
    "comment-medical",
    "comment-slash",
    "comments",
    "comments-dollar",
    "compact-disc",
    "compass",
    "compress",
    "compress-alt",
    "compress-arrows-alt",
    "concierge-bell",
    "cookie",
    "cookie-bite",
    "copy",
    "copyright",
    "couch",
    "credit-card",
    "crop",
    "crop-alt",
    "cross",
    "crosshairs",
    "crow",
    "crown",
    "crutch",
    "cube",
    "cubes",
    "cut",
    "database",
    "deaf",
    "democrat",
    "desktop",
    "dharmachakra",
    "diagnoses",
    "dice",
    "dice-d20",
    "dice-d6",
    "dice-five",
    "dice-four",
    "dice-one",
    "dice-six",
    "dice-three",
    "dice-two",
    "digital-tachograph",
    "directions",
    "disease",
    "divide",
    "dizzy",
    "dna",
    "dog",
    "dollar-sign",
    "dolly",
    "dolly-flatbed",
    "donate",
    "door-closed",
    "door-open",
    "dot-circle",
    "dove",
    "download",
    "drafting-compass",
    "dragon",
    "draw-polygon",
    "drum",
    "drum-steelpan",
    "drumstick-bite",
    "dumbbell",
    "dumpster",
    "dumpster-fire",
    "dungeon",
    "edit",
    "egg",
    "eject",
    "ellipsis-h",
    "ellipsis-v",
    "empty-set",
    "envelope",
    "envelope-open",
    "envelope-open-text",
    "envelope-square",
    "equals",
    "eraser",
    "ethernet",
    "euro-sign",
    "exchange-alt",
    "exclamation",
    "exclamation-circle",
    "exclamation-triangle",
    "expand",
    "expand-alt",
    "expand-arrows-alt",
    "external-link-alt",
    "external-link-square-alt",
    "eye",
    "eye-dropper",
    "eye-slash",
    "fan",
    "fast-backward",
    "fast-forward",
    "faucet",
    "fax",
    "feather",
    "feather-alt",
    "female",
    "fighter-jet",
    "file",
    "file-alt",
    "file-archive",
    "file-audio",
    "file-code",
    "file-contract",
    "file-csv",
    "file-download",
    "file-excel",
    "file-export",
    "file-image",
    "file-import",
    "file-invoice",
    "file-invoice-dollar",
    "file-medical",
    "file-medical-alt",
    "file-pdf",
    "file-powerpoint",
    "file-prescription",
    "file-signature",
    "file-upload",
    "file-video",
    "file-word",
    "fill",
    "fill-drip",
    "film",
    "filter",
    "fingerprint",
    "fire",
    "fire-alt",
    "fire-extinguisher",
    "first-aid",
    "fish",
    "fist-raised",
    "flag",
    "flag-checkered",
    "flag-usa",
    "flask",
    "flushed",
    "folder",
    "folder-minus",
    "folder-open",
    "folder-plus",
    "font",
    "football-ball",
    "forward",
    "frog",
    "frown",
    "frown-open",
    "function",
    "funnel-dollar",
    "futbol",
    "gamepad",
    "gas-pump",
    "gavel",
    "gem",
    "genderless",
    "ghost",
    "gift",
    "gifts",
    "glass-cheers",
    "glass-martini",
    "glass-martini-alt",
    "glass-whiskey",
    "glasses",
    "globe",
    "globe-africa",
    "globe-americas",
    "globe-asia",
    "globe-europe",
    "golf-ball",
    "gopuram",
    "graduation-cap",
    "greater-than",
    "greater-than-equal",
    "grimace",
    "grin",
    "grin-alt",
    "grin-beam",
    "grin-beam-sweat",
    "grin-hearts",
    "grin-squint",
    "grin-squint-tears",
    "grin-stars",
    "grin-tears",
    "grin-tongue",
    "grin-tongue-squint",
    "grin-tongue-wink",
    "grin-wink",
    "grip-horizontal",
    "grip-lines",
    "grip-lines-vertical",
    "grip-vertical",
    "guitar",
    "h-square",
    "hamburger",
    "hammer",
    "hamsa",
    "hand-holding",
    "hand-holding-heart",
    "hand-holding-medical",
    "hand-holding-usd",
    "hand-holding-water",
    "hand-lizard",
    "hand-middle-finger",
    "hand-paper",
    "hand-peace",
    "hand-point-down",
    "hand-point-left",
    "hand-point-right",
    "hand-point-up",
    "hand-pointer",
    "hand-rock",
    "hand-scissors",
    "hand-sparkles",
    "hand-spock",
    "hands",
    "hands-helping",
    "hands-wash",
    "handshake",
    "handshake-alt-slash",
    "handshake-slash",
    "hanukiah",
    "hard-hat",
    "hashtag",
    "hat-cowboy",
    "hat-cowboy-side",
    "hat-wizard",
    "hdd",
    "head-side-cough",
    "head-side-cough-slash",
    "head-side-mask",
    "head-side-virus",
    "heading",
    "headphones",
    "headphones-alt",
    "headset",
    "heart",
    "heart-broken",
    "heartbeat",
    "helicopter",
    "highlighter",
    "hiking",
    "hippo",
    "history",
    "hockey-puck",
    "holly-berry",
    "home",
    "horse",
    "horse-head",
    "hospital",
    "hospital-alt",
    "hospital-symbol",
    "hospital-user",
    "hot-tub",
    "hotdog",
    "hotel",
    "hourglass",
    "hourglass-end",
    "hourglass-half",
    "hourglass-start",
    "house-damage",
    "house-user",
    "hryvnia",
    "i-cursor",
    "ice-cream",
    "icicles",
    "icons",
    "id-badge",
    "id-card",
    "id-card-alt",
    "igloo",
    "image",
    "images",
    "inbox",
    "indent",
    "industry",
    "infinity",
    "info",
    "info-circle",
    "integral",
    "intersection",
    "italic",
    "jedi",
    "joint",
    "journal-whills",
    "kaaba",
    "key",
    "keyboard",
    "khanda",
    "kiss",
    "kiss-beam",
    "kiss-wink-heart",
    "kiwi-bird",
    "lambda",
    "landmark",
    "language",
    "laptop",
    "laptop-code",
    "laptop-house",
    "laptop-medical",
    "laugh",
    "laugh-beam",
    "laugh-squint",
    "laugh-wink",
    "layer-group",
    "leaf",
    "lemon",
    "less-than",
    "less-than-equal",
    "level-down-alt",
    "level-up-alt",
    "life-ring",
    "lightbulb",
    "link",
    "lira-sign",
    "list",
    "list-alt",
    "list-ol",
    "list-ul",
    "location-arrow",
    "lock",
    "lock-open",
    "long-arrow-alt-down",
    "long-arrow-alt-left",
    "long-arrow-alt-right",
    "long-arrow-alt-up",
    "low-vision",
    "luggage-cart",
    "lungs",
    "lungs-virus",
    "magic",
    "magnet",
    "mail-bulk",
    "male",
    "map",
    "map-marked",
    "map-marked-alt",
    "map-marker",
    "map-marker-alt",
    "map-pin",
    "map-signs",
    "marker",
    "mars",
    "mars-double",
    "mars-stroke",
    "mars-stroke-h",
    "mars-stroke-v",
    "mask",
    "medal",
    "medkit",
    "meh",
    "meh-blank",
    "meh-rolling-eyes",
    "memory",
    "menorah",
    "mercury",
    "meteor",
    "microchip",
    "microphone",
    "microphone-alt",
    "microphone-alt-slash",
    "microphone-slash",
    "microscope",
    "minus",
    "minus-circle",
    "minus-square",
    "mitten",
    "mobile",
    "mobile-alt",
    "money-bill",
    "money-bill-alt",
    "money-bill-wave",
    "money-bill-wave-alt",
    "money-check",
    "money-check-alt",
    "monument",
    "moon",
    "mortar-pestle",
    "mosque",
    "motorcycle",
    "mountain",
    "mouse",
    "mouse-pointer",
    "mug-hot",
    "music",
    "network-wired",
    "neuter",
    "newspaper",
    "not-equal",
    "notes-medical",
    "object-group",
    "object-ungroup",
    "oil-can",
    "om",
    "omega",
    "otter",
    "outdent",
    "pager",
    "paint-brush",
    "paint-roller",
    "palette",
    "pallet",
    "paper-plane",
    "paperclip",
    "parachute-box",
    "paragraph",
    "parking",
    "passport",
    "pastafarianism",
    "paste",
    "pause",
    "pause-circle",
    "paw",
    "peace",
    "pen",
    "pen-alt",
    "pen-fancy",
    "pen-nib",
    "pen-square",
    "pencil-alt",
    "pencil-ruler",
    "people-arrows",
    "people-carry",
    "pepper-hot",
    "percent",
    "percentage",
    "person-booth",
    "phone",
    "phone-alt",
    "phone-slash",
    "phone-square",
    "phone-square-alt",
    "phone-volume",
    "photo-video",
    "pi",
    "piggy-bank",
    "pills",
    "pizza-slice",
    "place-of-worship",
    "plane",
    "plane-arrival",
    "plane-departure",
    "plane-slash",
    "play",
    "play-circle",
    "plug",
    "plus",
    "plus-circle",
    "plus-square",
    "podcast",
    "poll",
    "poll-h",
    "poo",
    "poo-storm",
    "poop",
    "portrait",
    "pound-sign",
    "power-off",
    "pray",
    "praying-hands",
    "prescription",
    "prescription-bottle",
    "prescription-bottle-alt",
    "print",
    "procedures",
    "project-diagram",
    "pump-medical",
    "pump-soap",
    "puzzle-piece",
    "qrcode",
    "question",
    "question-circle",
    "quidditch",
    "quote-left",
    "quote-right",
    "quran",
    "radiation",
    "radiation-alt",
    "rainbow",
    "random",
    "receipt",
    "record-vinyl",
    "recycle",
    "redo",
    "redo-alt",
    "registered",
    "remove-format",
    "reply",
    "reply-all",
    "republican",
    "restroom",
    "retweet",
    "ribbon",
    "ring",
    "road",
    "robot",
    "rocket",
    "route",
    "rss",
    "rss-square",
    "ruble-sign",
    "ruler",
    "ruler-combined",
    "ruler-horizontal",
    "ruler-vertical",
    "running",
    "rupee-sign",
    "sad-cry",
    "sad-tear",
    "satellite",
    "satellite-dish",
    "save",
    "school",
    "screwdriver",
    "scroll",
    "sd-card",
    "search",
    "search-dollar",
    "search-location",
    "search-minus",
    "search-plus",
    "seedling",
    "server",
    "shapes",
    "share",
    "share-alt",
    "share-alt-square",
    "share-square",
    "shekel-sign",
    "shield-alt",
    "shield-virus",
    "ship",
    "shipping-fast",
    "shoe-prints",
    "shopping-bag",
    "shopping-basket",
    "shopping-cart",
    "shower",
    "shuttle-van",
    "sigma",
    "sign",
    "sign-in-alt",
    "sign-language",
    "sign-out-alt",
    "signal",
    "signal-alt",
    "signal-alt-slash",
    "signal-slash",
    "signature",
    "sim-card",
    "sink",
    "sitemap",
    "skating",
    "skiing",
    "skiing-nordic",
    "skull",
    "skull-crossbones",
    "slash",
    "sleigh",
    "sliders-h",
    "smile",
    "smile-beam",
    "smile-wink",
    "smog",
    "smoking",
    "smoking-ban",
    "sms",
    "snowboarding",
    "snowflake",
    "snowman",
    "snowplow",
    "soap",
    "socks",
    "solar-panel",
    "sort",
    "sort-alpha-down",
    "sort-alpha-down-alt",
    "sort-alpha-up",
    "sort-alpha-up-alt",
    "sort-amount-down",
    "sort-amount-down-alt",
    "sort-amount-up",
    "sort-amount-up-alt",
    "sort-down",
    "sort-numeric-down",
    "sort-numeric-down-alt",
    "sort-numeric-up",
    "sort-numeric-up-alt",
    "sort-up",
    "spa",
    "space-shuttle",
    "spell-check",
    "spider",
    "spinner",
    "splotch",
    "spray-can",
    "square",
    "square-full",
    "square-root",
    "square-root-alt",
    "stamp",
    "star",
    "star-and-crescent",
    "star-half",
    "star-half-alt",
    "star-of-david",
    "star-of-life",
    "step-backward",
    "step-forward",
    "stethoscope",
    "sticky-note",
    "stop",
    "stop-circle",
    "stopwatch",
    "stopwatch-20",
    "store",
    "store-alt",
    "store-alt-slash",
    "store-slash",
    "stream",
    "street-view",
    "strikethrough",
    "stroopwafel",
    "subscript",
    "subway",
    "suitcase",
    "suitcase-rolling",
    "sun",
    "superscript",
    "surprise",
    "swatchbook",
    "swimmer",
    "swimming-pool",
    "synagogue",
    "sync",
    "sync-alt",
    "syringe",
    "table",
    "table-tennis",
    "tablet",
    "tablet-alt",
    "tablets",
    "tachometer-alt",
    "tag",
    "tags",
    "tally",
    "tape",
    "tasks",
    "taxi",
    "teeth",
    "teeth-open",
    "temperature-high",
    "temperature-low",
    "tenge",
    "terminal",
    "text-height",
    "text-width",
    "th",
    "th-large",
    "th-list",
    "theater-masks",
    "thermometer",
    "thermometer-empty",
    "thermometer-full",
    "thermometer-half",
    "thermometer-quarter",
    "thermometer-three-quarters",
    "theta",
    "thumbs-down",
    "thumbs-up",
    "thumbtack",
    "ticket-alt",
    "tilde",
    "times",
    "times-circle",
    "tint",
    "tint-slash",
    "tired",
    "toggle-off",
    "toggle-on",
    "toilet",
    "toilet-paper",
    "toilet-paper-slash",
    "toolbox",
    "tools",
    "tooth",
    "torah",
    "torii-gate",
    "tractor",
    "trademark",
    "traffic-light",
    "trailer",
    "train",
    "tram",
    "transgender",
    "transgender-alt",
    "trash",
    "trash-alt",
    "trash-restore",
    "trash-restore-alt",
    "tree",
    "trophy",
    "truck",
    "truck-loading",
    "truck-monster",
    "truck-moving",
    "truck-pickup",
    "tshirt",
    "tty",
    "tv",
    "umbrella",
    "umbrella-beach",
    "underline",
    "undo",
    "undo-alt",
    "union",
    "universal-access",
    "university",
    "unlink",
    "unlock",
    "unlock-alt",
    "upload",
    "user",
    "user-alt",
    "user-alt-slash",
    "user-astronaut",
    "user-check",
    "user-circle",
    "user-clock",
    "user-cog",
    "user-edit",
    "user-friends",
    "user-graduate",
    "user-injured",
    "user-lock",
    "user-md",
    "user-minus",
    "user-ninja",
    "user-nurse",
    "user-plus",
    "user-secret",
    "user-shield",
    "user-slash",
    "user-tag",
    "user-tie",
    "user-times",
    "users",
    "users-cog",
    "users-slash",
    "utensil-spoon",
    "utensils",
    "value-absolute",
    "vector-square",
    "venus",
    "venus-double",
    "venus-mars",
    "vest",
    "vest-patches",
    "vial",
    "vials",
    "video",
    "video-slash",
    "vihara",
    "virus",
    "virus-slash",
    "viruses",
    "voicemail",
    "volleyball-ball",
    "volume",
    "volume-down",
    "volume-mute",
    "volume-off",
    "volume-slash",
    "volume-up",
    "vote-yea",
    "vr-cardboard",
    "walking",
    "wallet",
    "warehouse",
    "water",
    "wave-square",
    "weight",
    "weight-hanging",
    "wheelchair",
    "wifi",
    "wifi-slash",
    "wind",
    "window-close",
    "window-maximize",
    "window-minimize",
    "window-restore",
    "wine-bottle",
    "wine-glass",
    "wine-glass-alt",
    "won-sign",
    "wrench",
    "x-ray",
    "yen-sign",
    "yin-yang",
  ],
};
